import React, { useState } from 'react';
import ActionDropDown from '~/components/ActionDropDown/ActionDropDown';
import { CreateBuildingForm } from '~/components/CreateBuildingForm/CreateBuildingForm';
import GenericModal from '~/components/GenericModal/GenericModal';
import AddDownArrowIcon from '~/utils/images/add-downArrow.svg';
import MenuIcon from '~/utils/images/menu.svg';
import { getCreateBuildingFormConfig, timezoneOptions } from './constants';
import CobuConstants from '~/helpers/cobuConstants';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '~/redux/store';
import { Roles } from '~/enums/Roles';

const goToMap = new Map([
  ['UserManagement', `/building/admins`],
  ['PostManagement', `/building/pinned-post-management`],
  ['PostManagementCreate', `/building/pinned-post-management/post-management`],
  ['EventManagement', `/building/event-management`],
  ['SurveyManagement', `/building/surveys`],
  ['TooltipManagement', `/building/tooltips`],
  ['OwnershipPMManagement', `/building/ownerManagement`],
  ['PropertyAssignments', `/building/properyAssignment`],
  ['PMSIntegration', `/pms-integrations`],
  ['UserTenantMatching', `/tenant-management/tenant-matching`],
  ['FlyersManagement', `/building/flyerManagement`],
  ['BuildingKeys', `/building/buildingKeys`],
  ['EventReminder', `/building/eventReminder`],
  ['Audits', `/building/audits`],
  ['Questionnaires', `/building/cobu/questionnaires`],
  ['DeeplinksbyBranch', `/building/deeplinksbybranch`],
  ['ManageWords', `/building/manage-words`],
  ['LargeCsvUpload', `/building/large-csv-upload`],
  ['UniversalButtonManagement', `/building/universal-buttons`],
  ['GlobalKeysManagement', `/building/global-keys`],
  ['PartnerBuildingApproval', `/building/partner-building-approval`],
  ['NotificationAudit', `/building/notification-audit`],
  ['GlobalEventTemplateManagement', `/building/global-event-templates`],
  ['RetentionQAReport', `/building/retention-qa-report`]
]);

export const CreateMenu = () => {
  const history = useHistory();

  const [showBuildingForm, setShowBuildingForm] = useState(false);

  const role = useSelector((state: RootState) => {
    return state.auth.userRole;
  });

  const isFullAdmin = role === Roles.Vcm || role === Roles.Superadmin;

  const toggleShowBuildingForm = () => {
    history.push('/building/create');
  };

  const goto = (name: string) => {
    history.push(goToMap.get(name));
  };

  const pmToolsOptions = [
    {
      label: 'Post Management',
      name: 'PostManagementCreate',
      action: function () {
        goto(this.name!);
      }
    }
  ];

  const fullToolsOptions = [
    {
      label: 'User Management',
      name: 'UserManagement',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Post Management',
      name: 'PostManagement',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Event Management',
      name: 'EventManagement',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Survey Management',
      name: 'SurveyManagement',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Tooltip Management',
      name: 'TooltipManagement',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Universal Button Management',
      name: 'UniversalButtonManagement',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Ownership / PM Management',
      name: 'OwnershipPMManagement',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Property Assignments',
      name: 'PropertyAssignments',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'PMS Integrations',
      name: 'PMSIntegration',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'User-Tenant Matching',
      name: 'UserTenantMatching',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Flyers Management',
      name: 'FlyersManagement',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Building Keys',
      name: 'BuildingKeys',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Lack Of Event Reminder',
      name: 'EventReminder',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Audits',
      name: 'Audits',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Deeplinks by Branch',
      name: 'DeeplinksbyBranch',
      action: function () {
        goto(this.name!);
      }
    },
    {
      label: 'Retention QA Report',
      name: 'RetentionQAReport',
      action: function () {
        goto(this.name!);
      }
    },

    ...(role === Roles.Superadmin
      ? [
        {
          label: 'Cobu Questionnaires',
          name: 'Questionnaires',
          action: function () {
            goto(this.name!);
          }
        },
        {

          label: 'Manage Words',
          name: 'ManageWords',
          action: function () {
            goto(this.name!);
          }
        },
        {

          label: 'Large CSV Upload',
          name: 'LargeCsvUpload',
          action: function () {
            goto(this.name!);
          }
        },
        {
          label: 'Global Keys Management',
          name: 'GlobalKeysManagement',
          action: function () {
            goto(this.name!);
          }
        },
        {
          label: 'Partner Building Approval',
          name: 'PartnerBuildingApproval',
          action: function () {
            goto(this.name!);
          }
        },
        {
          label: 'Notification Audit',
          name: 'NotificationAudit',
          action: function () {
            goto(this.name!);
          }
        },
        {
          label: 'Global Event Template Management',
          name: 'GlobalEventTemplateManagement',
          action: function () {
            goto(this.name!);
          }
        }
      ]
      : [])
  ];

  const toolsOptions = isFullAdmin ? fullToolsOptions : pmToolsOptions;

  return (
    <>
      <ActionDropDown
        title={'Tools'}
        showIcon
        icon={<img src={MenuIcon} style={{ width: 40, height: 35 }} />}
        optionStyles={{ color: 'var(--cobuDarkBlue)' }}
        containerStyles={{
          backgroundColor: 'var(--cobuDarkBlue)',
          borderColor: 'var(--cobuDarkBlue)',
          flexDirection: 'column',
          zIndex: 99
        }}
        options={toolsOptions}
      />

      {isFullAdmin && (
        <ActionDropDown
          title={'Create'}
          showIcon
          icon={<img src={AddDownArrowIcon} style={{ width: 40, height: 35 }} />}
          optionStyles={{ color: 'var(--cobuDarkBlue)' }}
          containerStyles={{
            backgroundColor: 'var(--cobuDarkBlue)',
            borderColor: 'var(--cobuDarkBlue)',
            flexDirection: 'column'
          }}
          options={[
            {
              label: 'Building',
              action: toggleShowBuildingForm
            }
          ]}
        />
      )}
    </>
  );
};
